//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { CenteredSpinner } from '@components/atoms/spinner/Spinner';
import makeAngularReactController from '@react-bridge/angular-react-widget';
import { UIADetails } from '@uia/details/UIADetails';
import { UIAShareToastStyles } from '@uia/share/UIAShareToastStyles';
import { getRootCuid } from '@uia/details/selectors/getUIAReactPortItemDetails';
import { isDefined } from '@utils/filterPredicates';

const UniversalImageActionsDetails = () => {
  const cuid = useSelector(getRootCuid);

  return (
    <div className='unison-component'>
      <UIAShareToastStyles />
      {(() => {
        return isDefined(cuid) ? (
          <UIADetails cuid={cuid} />
        ) : (
          <Wrapper>
            <CenteredSpinner />
          </Wrapper>
        );
      })()}
    </div>
  );
};

const Wrapper = styled.div(
  ({ theme }) => `
    padding: ${theme.spacings[5]};
  `,
);

angular.module('curalate').component('uiaDetails', {
  controller: makeAngularReactController(<UniversalImageActionsDetails />),
});
